import React from "react";
import assign from "object-assign";
import classnames from "classnames";
import GrComponentFactory from "../gr_component_factory";

const getSlideClasses = (spec) => {

  let slideCloned, index;

  index = spec.slideIndex;
  slideCloned = (index < 0) || (index >= spec.trackSlidesCount);
  return classnames({
    "gr-carousel__slide": true,
    "carousel-cloned": slideCloned,
  });
};

const getSlideStyle = function (spec) {
  const style = {};

  style.width = spec.trackSlideContainerWidth;
  return style;
};

// Determines if aria-hidden should be set to hide
// slide from screen readers (for off-screen slides)
const shouldHideSlideFromAria = (slideIndex, currentSlideIndex, slidesToShow) => {
  const slidesFromFirstShownSlide = slideIndex - currentSlideIndex;
  return (slidesFromFirstShownSlide < 0) || (slidesFromFirstShownSlide >= slidesToShow);
};

const renderSlides = (spec) => {

  if (spec.trackCurrentSlide==null || !spec.trackSlides) {
    return null;
  }
  const slides = [];
  const preCloneSlides = [];
  const postCloneSlides = [];

  React.Children.forEach(spec.trackSlides, (elem, index) => {
    const childElement = React.cloneElement(elem, assign({
      carouselId: spec.carouselId,
      currentSlide: spec.trackCurrentSlide,
      slideIndex: index,
      slidesToShow: spec.trackSlidesToShow,
      sidesToScroll: spec.trackSlidesToScroll,
      slideCount: spec.trackSlidesCount,
      slideWidth: spec.trackSlideContainerWidth },
        elem.props));

    const trackElement = (<div>{childElement}</div>);
    const slideStyle = getSlideStyle(assign({ slideIndex: index }, spec));
    const slideClasses = getSlideClasses(assign({ slideIndex: index }, spec));

    if (spec.trackCurrentSlide - spec.trackSlidesToScroll <= index && index < (spec.trackCurrentSlide + spec.trackSlidesToShow + spec.trackSlidesToScroll)) {

      slides.push(React.cloneElement(trackElement, {
        "aria-hidden": shouldHideSlideFromAria(index, spec.trackCurrentSlide, spec.trackSlidesToShow),
        key: `original${  index}`,
        "data-index": index,
        className: slideClasses,
        style: assign({}, elem.props.style || {}, slideStyle),
      }));
    }

    if (spec.trackWrapAround) {
      if (((spec.trackCurrentSlide - spec.trackSlidesToScroll) < 0 ) && (index >= (spec.trackSlidesCount + spec.trackCurrentSlide - spec.trackSlidesToScroll))) {
        const key = -(spec.trackSlidesCount - index);
        preCloneSlides.push (React.cloneElement(trackElement, {
          "aria-hidden": shouldHideSlideFromAria(index, spec.trackCurrentSlide, spec.trackSlidesToShow),
          key: `cloned${  key}`,
          "data-index": key,
          className: slideClasses,
          style: assign({}, elem.props.style || {}, slideStyle),
        }));
      }

      else if ((spec.trackCurrentSlide + spec.trackSlidesToShow >= spec.trackSlidesCount) && (index < spec.trackCurrentSlide + spec.trackSlidesToShow - spec.trackSlidesCount)) {
        const key =  index + spec.trackSlidesCount;
        postCloneSlides.push (React.cloneElement(trackElement, {
          "aria-hidden": shouldHideSlideFromAria(index, spec.trackCurrentSlide, spec.trackSlidesToShow),
          key: `cloned${  key}`,
          "data-index": key,
          className: slideClasses,
          style: assign({}, elem.props.style || {}, slideStyle),
        }));
      }

      else if ((spec.trackCurrentSlide + (spec.trackSlidesToShow + spec.trackSlidesToScroll) > spec.trackSlidesCount) && (index < spec.trackCurrentSlide + (spec.trackSlidesToShow + spec.trackSlidesToScroll) - spec.trackSlidesCount)) {
        const key =  index + spec.trackSlidesCount;
        postCloneSlides.push (React.cloneElement(trackElement, {
          "aria-hidden": shouldHideSlideFromAria(index, spec.trackCurrentSlide, spec.trackSlidesToShow),
          key: `cloned${  key}`,
          "data-index": key,
          className: slideClasses,
          style: assign({}, elem.props.style || {}, slideStyle),
        }));
      }

    }
  });

  return preCloneSlides.concat(slides, postCloneSlides);

};

export default GrComponentFactory.createClass({

  displayName: "SlideTrack",

  propTypes: {
    carouselId: React.PropTypes.string,
    trackCurrentSlide: React.PropTypes.number,
    trackWrapAround: React.PropTypes.bool,
    trackSlides: React.PropTypes.array,
    trackSlidesCount: React.PropTypes.number,
    trackSlidesToScroll: React.PropTypes.number,
    trackSlidesToShow: React.PropTypes.number,
    trackSlideContainerWidth: React.PropTypes.number,
    trackStyle: React.PropTypes.object,
  },

  render () {
    const slides = renderSlides(this.props);
    return (
        <div className={classnames("gr-carousel__track")} style={this.props.trackStyle}>
          {slides}
        </div>
    );
  },
});
